import React, { useState, useEffect, useRef } from 'react';
import { PromotionVoucher } from 'types/Product';
import InsuranceVoucherCard from './Card/InsuranceVoucherCard';
import InsuranceVoucherDialog from './Dialog/InsuranceVoucherDialog';

type Props = {
  promotionVoucher: PromotionVoucher;
};

function InsuranceVoucher(props: Props) {
  const { promotionVoucher } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogRendered, setDialogRendered] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (dialogRendered) {
      setDialogOpen(true);
    }
  }, [dialogRendered]);

  const openDialog = () => {
    if (dialogRendered) {
      setDialogOpen(true);
    } else {
      setDialogRendered(true);
    }
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const renderVoucher = () => (
    <>
      <InsuranceVoucherCard promotionVoucher={promotionVoucher} onClickCallback={openDialog} />

      {dialogRendered && (
        <InsuranceVoucherDialog promotionVoucher={promotionVoucher} onClose={closeDialog} open={dialogOpen} />
      )}
    </>
  );

  return <div data-testid="insurance-promotion-voucher">{renderVoucher()}</div>;
}

export default InsuranceVoucher;
